<!--
 * @Author:
 * @LastEditTime: 2024-07-09 15:58:24
 * @Description:
-->
<template>
  <div class="operation-panel bg-transparent rounded-2px z-99 w-full h-full pt-10px">
    <div class="flex justify-between items-center">
      <CategoryTitle title="两票列表"></CategoryTitle>
      <TableButtonGroup v-model="activeTab" :list="tabList" @btn-click="tabClick" />
    </div>
    <div class="mb-10px flex items-center mt-10px el-select_t ">
      <el-select
        multiple
        filterable
        clearable
        collapse-tags
        collapse-tags-tooltip
        popper-class="visualization-select-popper"
        placeholder="作业类型"
        class="mr-5px "
        v-model="WorkTicketsParams.ticketTypes"
        @change="searchWorkTickets"
      >
        <el-option
          v-for="(item, index) in typeOption"
          :key="'type' + index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        multiple
        filterable
        clearable
        popper-class="visualization-select-popper"
        placeholder="风险等级"
        collapse-tags
        class="mr-5px"
        v-model="WorkTicketsParams.riskWorkticketLevels"
        @change="searchWorkTickets"
      >
        <el-option
          v-for="(item, index) in levelOption"
          :key="'level' + index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        filterable
        clearable
        popper-class="visualization-select-popper"
        placeholder="作业状态"
        collapse-tags
        v-model="WorkTicketsParams.status"
        @change="searchWorkTickets"
        class="status-select"
      >
        <el-option
          v-for="(item, index) in statusOption"
          :key="'level' + index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <el-table
      ref="tableRef"
      height="calc(100% - 110px)"
      class="mt-10px"
      :data="detailList"
      highlight-current-row
      row-key="id"
      v-loading="WorkTicketsLoading"
      :row-style="rowStyle"
      @row-click="openDetail"
    >
      <el-table-column label="作业类型" prop="prTicketTypeName" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="作业内容" prop="prWorkContent" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="作业状态" prop="prTicketState" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column label="工作负责人" prop="prWorkManagerName" show-overflow-tooltip>
      </el-table-column> -->
    </el-table>
    <el-pagination
      small
      background
      :current-page.sync="WorkTicketsParams.pageNo"
      :page-size.sync="WorkTicketsParams.pageSize"
      pager-count="3"
      layout="total, prev, pager, next"
      :total="WorkTicketsParams.total"
      @current-change="workTicketsChangePage"
      class="text-center"
    ></el-pagination>
  </div>
</template>

<script>
// apis
import { WorkTicketsApi } from '@wiz-api/huizhou2-business'
import { DataCategoryApi } from '@wiz-api/data-category-management'
// tools
import { filter, map, forEach, isEmpty } from 'lodash'

// components
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import TableButtonGroup from '@/components/cockpit/TableButtonGroup'
import RiskAssignment from '../../../assets/js/componentMethods/riskAssignment'
import dayjs from 'dayjs'

//
const workTicketsApi = new WorkTicketsApi()
const dataCategoryApi = new DataCategoryApi()

export default {
  components: {
    CategoryTitle,
    TableButtonGroup,
  },
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      test: 1,
      activeTab: '工作票',
      tabList: ['工作票', '操作票'],
      detailList: [],
      WorkTicketsParams: {
        beginTime: dayjs().startOf('day').subtract(29, 'day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        ids: [],
        keyword: '',
        type: '',
        ticketTypes: [],
        status: '',
        total: 0,
        pageNo: 1,
        pageSize: 15,
        riskWorkticketLevels: [],
      },
      WorkTicketsLoading: false,
      typeOption: [],
      levelOption: [
        { value: '低', label: '低' },
        { value: '中', label: '中' },
        { value: '高', label: '高' },
      ],
      statusOption: [
        { value: 'WaitCommit', label: '待提交' },
        { value: 'WaitApprove', label: '待审批' },
        { value: 'Executing', label: '正在执行' },
        { value: 'Finished', label: '已完成' },
        { value: 'Cancel', label: '已作废' },
        { value: 'Expired', label: '已过期' },
        { value: 'Archived', label: '已归档' },
      ]
    }
  },
  watch: {},
  computed: {},
  async created() {
    this.WorkTicketsParams.ticketTypes = this.transferProps?.prTicketType
      ? [this.transferProps.prTicketType]
      : []
    this.getData()
  },
  methods: {
    openDetail(buildingId) {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'ElectricalWorkVote',
            origin: 'tag',
            name: buildingId.prTicketTypeName,
            originTagName: 'RiskAssignment',
          },
          type: 'tags',
          props: {
            buildingId,
          },
        },
      })
      window.dispatchEvent(openEvent)
      // 定位
      this.cloudRender.Camera.moveCamera('Code', buildingId.prDeviceCode)
    },
    showHideMarkers(list) {
      RiskAssignment.hiddenMarkes(
        filter(map(list, 'prDeviceCode'), (item) => {
          return item
        })
      )
    },
    rowStyle({ row }) {
      switch (row.riskWorkticketLevel) {
        case '高':
          return {
            color: '#e33333',
          }
        case '中':
          return {
            color: '#feff00',
          }
        default:
          return ''
      }
    },
    getData() {
      this.getWorkTickets()
      this.getTypeOption()
    },
    // 表单数据获取
    async getWorkTickets() {
      this.WorkTicketsLoading = true
      const [err, res] = await workTicketsApi.getWorkticketByPage({ body: this.WorkTicketsParams })
      if (!err && res) {
        this.WorkTicketsParams.total = res.totalCount
        this.detailList = res.items
      }
      this.WorkTicketsLoading = false
    },
    // 筛选查询
    async searchWorkTickets() {
      // 清空下拉查询 展示全部图标
      if (
        isEmpty(this.WorkTicketsParams.ticketTypes) &&
        isEmpty(this.WorkTicketsParams.riskWorkticketLevels)
      ) {
        RiskAssignment.display()
        this.getWorkTickets()
      } else {
        await this.getWorkTickets()
        this.showHideMarkers(this.detailList)
      }
    },
    // 工作票类型下拉框选项获取
    async getTypeOption() {
      const [err, res] = await dataCategoryApi.getByCode({
        code: 'WorkingTicketType',
      })
      console.log('created', err, res)

      if (!err && res) {
        forEach(res.dataItems, (item) => {
          this.typeOption.push({
            value: item.code,
            label: item.displayName,
          })
        })
      }
    },
    workTicketsChangePage(val) {
      this.WorkTicketsParams.pageNo = val
      this.getWorkTickets()
    },
    tabClick() {
      console.log(this.activeTab)
    },
  },
  beforeDestroy() {
    RiskAssignment.display()
  },
}
</script>
<style lang="scss" scoped>
.el-select_t ::v-deep .el-select__tags {
  white-space: nowrap;
  overflow: hidden;
  flex-wrap: nowrap;
}
.el-select_t ::v-deep .el-select__tags-text {
  max-width: 36px;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-wrap: nowrap;
}
.status-select {
  ::v-deep .el-input__inner:not([tabindex]) {
    height: 40px !important;
  }
  ::v-deep .el-input .el-input__icon {
    line-height: 40px !important;
  }
}
</style>
